module.exports = __webpack_public_path__ + "media/icons/context-minus-371bbe90.svg";